export enum PriceRequestFormGoogleAnalyticsEvent {
  ViewPriceRequestForm = 'view_price_request_form',
  BeginPriceRequestForm = 'begin_price_request_form',
  QuoteStep1 = 'quote_step_1',
  QuoteStep2 = 'quote_step_2',
  QuoteNext = 'quote_next',
  QuoteClickSend = 'quote_click_send',
  QuoteLeadGen = 'quote_lead_gen',
  ErrorForm = 'error_form',
}
